module.exports = __webpack_public_path__ + "static/media/value-prop-1.aa9998d6.png";